exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".profileContainer[data-v-4c5975f0]{text-align:center;margin:auto;margin-bottom:1em}.imageContainer[data-v-4c5975f0]{width:100px;height:100px;padding:10px;margin:auto;position:relative;cursor:pointer}.menuSelect[data-v-4c5975f0]{max-width:90%}.mobileStyle[data-v-4c5975f0]{cursor:default!important}.imageContainer img[data-v-4c5975f0]{width:100%;height:100%;border-radius:100%}.imageContainer .md-icon[data-v-4c5975f0]{opacity:0;position:absolute;top:25%;left:25%;-webkit-transition:opacity .25s ease;transition:opacity .25s ease}.imageContainer:hover .md-icon[data-v-4c5975f0]{opacity:1}.profileContainer h5[data-v-4c5975f0]{font-weight:400;font-size:1em;margin:0 auto}.profileContainer h4[data-v-4c5975f0]{font-size:1em;margin:0;padding:0;color:#aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c5975f0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserContainer.vue
// module id = 361
// module chunks = 0